import { rehydrateAll } from "../rehydrate/rehydrateService";
import { socket } from "../api";
import {
  bootSocketManager,
  onReconnect,
} from "../socket/socketManager";
import { telemetry } from "../telemetry/telemetry";
import { startKeepAlive, warmup as warmupSpeech } from "./speechEngine";

let booted = false;

export function bootAudioPipeline(): void {
  if (booted) return;
  booted = true;

  telemetry("boot");

  warmupSpeech();
  startKeepAlive();
  bootSocketManager();

  // Em todo connect/reconnect, repoe estado via REST.
  onReconnect(() => {
    rehydrateAll().catch((err) =>
      console.error("[panel:rehydrate_threw]", err)
    );
  });

  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", onVisibilityChange);
  }
}

function onVisibilityChange(): void {
  if (typeof document === "undefined") return;
  const state = document.visibilityState;
  telemetry("visibility_change", { state });
  if (state === "visible") {
    warmupSpeech();
    if (!socket.connected) {
      try {
        socket.connect();
      } catch (err) {
        console.error("[panel:socket_connect_failed]", err);
      }
    }
    rehydrateAll().catch((err) =>
      console.error("[panel:rehydrate_threw]", err)
    );
  }
}
